import { render, staticRenderFns } from "./mockup5.vue?vue&type=template&id=2234235c&scoped=true"
import script from "./mockup5.vue?vue&type=script&lang=js"
export * from "./mockup5.vue?vue&type=script&lang=js"
import style0 from "./mockup5.vue?vue&type=style&index=0&id=2234235c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2234235c",
  null
  
)

export default component.exports